import { inject, NewInstance } from 'aurelia-framework';
import { PlantService } from 'pages/quote-setup/plants/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), PlantService, EventAggregator)
export class PlantEditor {
    constructor(controller, validationController, plantService, ea) {
        this.controller = controller;
        this.plantService = plantService;
        this.ea = ea;
        this.plant = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .ensure('code').required()
            .ensure('address').required()
            .ensure('city').required()
            .ensure('state').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.plant = await this.plantService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.plant.id) {
                    await this.plantService.update(this.plant);
                    toastr.success('Plant was updated!');
                } else {
                    await this.plantService.create(this.plant);
                    toastr.success('New plant was created!');
                }
                this.ea.publish('plants:updated', this.plant);
                this.controller.ok(this.plant);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}